module.exports = __webpack_public_path__ + "img/deskshelf.0c3df26d.png";